import * as analytics from '../vendor/analytics/index';
import { getParameterByName } from './queryStringHelper';
import templateData from './getTemplateData';
import _get from 'lodash/get';
import _find from 'lodash/find';
import { isOptInCoverFee } from '../components/coverFee/feeUtils';
import {
  isSdkMode,
  isPopupMode,
  isFullPageRedirectionMode,
} from './inContextDonation';
import AppStore from '../stores/AppStore';
import { normalizeNumber } from './formator';
import isEmpty from 'lodash/isEmpty';
import { EVENT_NAME, FPTI_PRODUCT, SCREEN_NAME } from './constants';
import {
  isExternalFlow,
  isGNC,
  isPPFundraising,
} from './externalIntegrationUtils';
import { isLoggedInUser } from './authUtils';

if (templateData.selectedPresetButtonId) {
  addSelectedPresetButton(templateData.selectedPresetButtonId);
}

if (templateData.feePayer) {
  window.fpti.fee_payer = templateData.feePayer;
  window.fpti.fee_amt = templateData.feeAmount;
  window.fpti.fee_curr = templateData.feeCurr;
  window.fpti.amount = normalizeNumber(templateData.donationAmount);
}

function parseFPTIValue(key) {
  let fptiData;
  try {
    fptiData = JSON.parse(document.getElementById('fptiData').innerHTML || {});
  } catch (e) {
    fptiData = {};
  }
  let nameValues = [];
  let pairs = decodeURIComponent(fptiData).split('&');
  let i;
  for (i = 0; i < pairs.length; i++) {
    let parts = pairs[i].split('=');
    nameValues[parts[0]] = parts[1];
  }
  return nameValues[key];
}

const urlToFptiMapping = [
  {
    url: '/donate/guest/crossborder',
    pgrp: 'main:donate:wps:guest:crossborder',
  },
  { url: '/donate/error/payment', pgrp: 'main:donate:wps:guest:failure' },
  { url: '/donate/member/success', pgrp: 'main:donate:wps:member:success' },
  {
    url: '/donate/member/confirmation-rec',
    pgrp: 'main:donate:wps:member:success',
  },
  {
    url: '/donate/member/confirmation',
    pgrp: 'main:donate:wps:member:success',
  },
  { url: '/donate/member/pending', pgrp: 'main:donate:wps:member:pending' },
  { url: '/donate/member/error', pgrp: 'main:donate:wps:member:failure' },
  { url: '/donate/member', pgrp: 'main:donate:wps:member:review' },
];

function getPgrp() {
  try {
    const windowUrl = window.location.href;
    const signup = getParameterByName('signup');
    if (signup) {
      return 'main:donate:wps:signup:signupform';
    }

    for (let i = 0; i < urlToFptiMapping.length; i++) {
      if (windowUrl.indexOf(urlToFptiMapping[i].url) > -1) {
        return urlToFptiMapping[i].pgrp;
      }
    }

    if (windowUrl.indexOf('/donate/guest/confirmation') > -1) {
      if (templateData.fptPageName === 'guestULSignUp') {
        return 'main:donate:wps:signup:success';
      }
      return 'main:donate:wps:guest:success';
    }

    if (windowUrl.indexOf('/donate/guest/pending') > -1) {
      if (templateData.fptPageName === 'guestULSignUp') {
        return 'main:donate:wps:signup:pending';
      }
      return 'main:donate:wps:guest:pending';
    }

    // Last of the guest pages
    if (windowUrl.indexOf('/donate/guest') > -1) {
      return 'main:donate:wps:guest:guestform';
    }

    // Last check. Is it landing page?
    if (windowUrl.indexOf('/donate') > -1) {
      return 'main:donate:wps::landing';
    }
  } catch (error) {
    trackError({
      message: 'FPTI_PGRP_ERROR',
      code: window.location.href,
      error,
    });
  }

  // No pages matched. Use value sent by server
  return {
    pgrp: parseFPTIValue('pgrp'),
    page: parseFPTIValue('page'),
  };
}

export function trackPage(pageGroup, pageName, custKey, custValue) {
  analytics.trackPage(pageGroup, pageName, custKey, custValue);
}

export function trackPageWithData(pageGroup, pageName, data) {
  analytics.trackPageWithData(pageGroup, pageName, data);
}

export function addPxpTags(data) {
  analytics.addPxpTags(data);
}

export function trackLinkClick(eventType) {
  const pgrp = getPgrp();
  analytics.trackLink(eventType, pgrp, `${pgrp}:web::`, 'link');
}

export function trackLinkClickWithData(eventType, data) {
  const pgrp = getPgrp();
  analytics.trackLinkWithData(eventType, pgrp, `${pgrp}:web::`, data, 'link');
}

export function trackButtonClick(eventType) {
  const pgrp = getPgrp();
  analytics.trackLink(eventType, pgrp, `${pgrp}:web::`, 'link');
}

export function trackButtonClickWithData(eventType, data) {
  const pgrp = getPgrp();
  analytics.trackLinkWithData(eventType, pgrp, `${pgrp}:web::`, data, 'link');
}

export function trackError(err) {
  analytics.trackError(err);
}

export function trackErrorWithData(data) {
  const pgrp = getPgrp();
  analytics.trackErrorWithData(pgrp, `${pgrp}:web::`, data);
}

export function trackFieldError(fieldId, errorCode, errorMessage) {
  const errorObj = {
    message: errorMessage,
    fieldId: fieldId,
    code: errorCode,
  };
  if (isExternalFlow()) {
    errorObj.event_name =
      EVENT_NAME.DW_GIVING_FAILED_CUSTOMER_INTERACTION_OCCURRED;
    errorObj.screen = SCREEN_NAME.DW_GIVING_DONATE_GUEST_FORM_SCREEN;
    errorObj.error_desc = errorMessage;
    errorObj.error_code = errorCode;
  }
  trackErrorWithData(errorObj);
}

export function addFi(fundingOpts, pageGroup, pageName) {
  window.fpti.fi_id = _get(fundingOpts, 'id');
  // payment card type
  window.fpti.fi_type = _get(fundingOpts, 'sources[0].payment_card.type');
  // payment card network
  window.fpti.sel_fmx_tp = _get(fundingOpts, 'sources[0].payment_card.network');
  window.fpti.fi_operation = 'add_card';
  trackPage(pageGroup, pageName);
}

export function addSelectedPresetButton(buttonId) {
  window.fpti.opsel = buttonId;
}

export function add3DSInitData(fundingOpts, pageGroup, pageName) {
  window.fpti.is_3ds_eligible = true;
  window.fpti['3ds_version'] = '3DS2.0';

  const contingencies = _get(fundingOpts, 'contingencies') || [];
  const threeDSContingency =
    _find(contingencies, { action: '3D_SECURE_DATA_COLLECTION_REQUIRED' }) ||
    {};
  window.fpti['3ds_ref_id'] = _get(threeDSContingency, 'three_ds_reference_id');
  trackPage(pageGroup, pageName);
}

export function add3DSRespDuration(data, pageGroup, pageName) {
  let resp_duration = window.fpti.resp_duration || {};
  resp_duration = Object.assign({}, resp_duration, data);
  window.fpti.resp_duration = resp_duration;
  trackPage(pageGroup, pageName);
}

export function add3DSChallengeStatus(data) {
  window.fpti.challenge_status = data;
}

export function addDonationAmount(amount, pageGroup, pageName) {
  window.fpti.amount = amount;
  trackPage(pageGroup, pageName);
}

export function trackFeeData() {
  window.fpti.fee_payer = isOptInCoverFee() ? 'consumer' : 'merchant';
  window.fpti.fee_amt = AppStore.getFeeAmount();
  window.fpti.fee_curr = AppStore.getDonationCode();
  trackDonationAmount();
}

export function addOnboardingBundleType(type = 'full') {
  window.fpti.onboardingBundleType = type;
}

export function trackIntegrationType() {
  const isSdkTxn = isSdkMode();
  if (!isSdkTxn) {
    window.fpti.ui_type = 'full_page';
    return;
  }
  if (isPopupMode()) {
    window.fpti.ui_type = 'popup';
  } else if (isFullPageRedirectionMode()) {
    window.fpti.ui_type = 'popup_blocked';
  }
}

export function trackNoteData(data) {
  window.fpti.is_allow_note = data?.noteFieldDisplayed || false;
  window.fpti.has_note = !isEmpty(AppStore.getDonationNote());
}

export function trackAnonymousData() {
  window.fpti.nonanonymous = AppStore.getAnonymousStatus() === 'unchecked';
}

export function trackAmountEditability() {
  window.fpti.allow_amount_edit = templateData.donationAmountEditable;
}

export function trackEventName(eventName) {
  window.fpti.event_name = eventName;
}

export function trackExternalFlowData() {
  window.fpti.product = FPTI_PRODUCT;
  window.fpti.flow = templateData.product;
  window.fpti.integration_identifier = templateData.integrationIdentifier;
  window.fpti.acct_cntry = templateData.donorIpCountry;
  window.fpti.account_type = isLoggedInUser() ? 'member' : 'guest';
  window.fpti.currency = templateData.donationCode;

  if (!isEmpty(templateData.productId)) {
    window.fpti.campaign_id = templateData.productId;
  }

  if (!isEmpty(templateData.npid)) {
    window.fpti.crid = templateData.npid;
  }

  if (isGNC() || isPPFundraising()) {
    window.fpti.charityname = templateData.donationName;
  }
}

export function trackDonationAmount() {
  window.fpti.amount = normalizeNumber(AppStore.getDonationAmount());
}

export function trackOfferType(offerType) {
  if (offerType === undefined) {
    delete window.fpti.offer_type;
  } else {
    window.fpti.offer_type = offerType;
  }
}

export function getOfferType() {
  return window.fpti.offer_type;
}

export function trackToken() {
  window.fpti.token = templateData.token;
}

export function trackSignupOption(isSignUp) {
  window.fpti.user_opts_signup = isSignUp;
}
